import styled from 'styled-components';

import Colours from '/shared/styled/Colours';

export default styled.div`
  position: relative;
  padding: 5rem 0;
  margin-top: 5rem;
  margin-bottom: -3rem;

  &::before {
    content: '';
    background: ${Colours.whiteDark1};
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100vw;
    left: 50%;
    right: 50%;
    /* @todo: This is because of the padding elsewhere. It's all nested so deep, what do we do instead? */
    margin-left: calc(-50vw + 2rem);
  }
`;
